
import { usePostHttp } from "../../../../hooks/http/http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  id: string;
}

export function useEmailResendOtpBrandHttp() {
  return usePostHttp<IBody, IOtp>({
    path: "/brand/authentication/email/otp/resend",
  });
}
